import { render, staticRenderFns } from "./AddLinks.vue?vue&type=template&id=4b4b16e4&scoped=true&"
import script from "./AddLinks.vue?vue&type=script&lang=js&"
export * from "./AddLinks.vue?vue&type=script&lang=js&"
import style0 from "./AddLinks.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddLinks.vue?vue&type=style&index=1&id=4b4b16e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b16e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4b16e4')) {
      api.createRecord('4b4b16e4', component.options)
    } else {
      api.reload('4b4b16e4', component.options)
    }
    module.hot.accept("./AddLinks.vue?vue&type=template&id=4b4b16e4&scoped=true&", function () {
      api.rerender('4b4b16e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/AddLinks.vue"
export default component.exports